import { type FunctionComponent } from 'react';

import { useHasReverseTrialExperience } from 'app/src/components/FreeTrial';
import { PremiumTrialModalOverlay } from './PremiumTrialModalOverlay';

const PREMIUM_TRIAL_MODAL_MESSAGE_DISMISSED_KEY_PREFIX =
  'premium-trial-modal-message-dismissed-for-ws';

export const PremiumTrialModalOverlays: FunctionComponent = () => {
  const hasReverseTrialExperience = useHasReverseTrialExperience();

  if (hasReverseTrialExperience) {
    return (
      <PremiumTrialModalOverlay
        messageDismissedKeyPrefix={
          PREMIUM_TRIAL_MODAL_MESSAGE_DISMISSED_KEY_PREFIX
        }
        analyticsAttributes={{
          acceptButtonName: 'acceptReverseTrialModalButton',
          extendTrialButtonName: 'extendReverseTrialModalButton',
          screenName: 'announceReverseTrialModalScreen',
        }}
      />
    );
  }

  return null;
};
